import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "shield-yes",
  "use": "shield-yes-usage",
  "viewBox": "0 0 15.97 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.97 20\" id=\"shield-yes\"><title>shield-yes</title><g id=\"shield-yes_Page-1\"><g id=\"shield-yes_solarman-v001\"><g id=\"shield-yes_Group-3\"><g id=\"shield-yes_Group-6\"><path id=\"shield-yes_Combined-Shape\" d=\"M10,0a21.08,21.08,0,0,0,7.34,3.17C19.2,9.5,17.13,17.26,10,20,2.87,17.26.8,9.5,2.66,3.17A21.08,21.08,0,0,0,10,0Zm4.21,6.23a.78.78,0,0,0-.55.26c-1.56,1.65-3,3.28-4.48,4.9L7.34,9.83a.77.77,0,0,0-.79-.13.84.84,0,0,0-.5.67.88.88,0,0,0,.29.79l2.41,2a.77.77,0,0,0,1.07-.06c1.73-1.84,3.28-3.65,5-5.45A.89.89,0,0,0,15,6.75.8.8,0,0,0,14.21,6.23Z\" transform=\"translate(-2.01)\" /></g></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/shield-yes.svg
// module id = L2Nn
// module chunks = 268